import axios from 'axios';

const BASE_URL = '/api/preguntas-frecuentes';

export const fqasDeleteService = {
  deleteFQA: async (empresaId, idVector, coleccionName) => {
    // idVector es el ID de la pregunta
    try {
      const response = await axios.delete(`${BASE_URL}/delete/${idVector}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting FAQ:', error);
      throw error;
    }
  }
};
